import React, { useCallback, useEffect, useMemo, useState } from 'react'
import classnames from 'classnames'
import styled from 'styled-components'
import Icon from '../Icon'

const CheckBoxstyled = styled.label`
  display: flex;
  svg {
    color: #ffffff;
  }
  &.disabled {
    cursor: not-allowed;
    svg {
      color: #474747;
    }
  }
`
interface Props {
  className?: string
  children?: React.ReactNode
  defaultChecked?: boolean
  disabled?: boolean
  onChange: (value: boolean) => void
}
export default function Checkbox(props: Props) {
  const { children, defaultChecked, className, disabled, onChange, ...rest } = props
  const [checked, setChecked] = useState(defaultChecked)

  useEffect(() => {
    setChecked(defaultChecked)
  }, [defaultChecked])

  const type = useMemo(() => {
    return checked
      ? 'yigouxuan'
      : 'weigouxuan'
  }, [checked])

  const handleChange = useCallback(() => {
    if (disabled) return
    setChecked(!checked)
    onChange?.(!checked)
  }, [checked, disabled])

  return (
    <CheckBoxstyled
      onClick={handleChange}
      className={classnames({ disabled }, className)}
      {...rest}
    >
      <>
        <Icon type={type} />
        {children}
      </>
    </CheckBoxstyled>
  )
}
